// extracted by mini-css-extract-plugin
export default {"wrapper":"StartNode_wrapper__7Rdc1","wrapperContainer":"StartNode_wrapperContainer__aC72e","icon":"StartNode_icon__j7s3-"};